import React, { FC, useEffect, useRef, useState } from "react";
import { generatePath, useHistory, useLocation } from "react-router-dom";
import "./instituteStudents.scss";
import avatarPlaceholder from "../../../../../src/assets/placeholder/avatar_placeholder.png"

import ButtonComponent from "../../../../shared/components/ButtonComponent";
import { SearchInput } from "../../../../shared/components/SearchInput";
import {
  DownloadOutlined,
  CaretDownOutlined,
  FilterOutlined,
  EllipsisOutlined,
} from "@ant-design/icons";
import { Table, Dropdown, Menu, Button, Spin, Modal, MenuProps, Switch } from "antd";
import PaginationComponent from "../../../../shared/components/PaginationComponent";
import { convertJSONToFormData } from "../../../../shared/utils/converJsonToFormData";
import Filters from "../../../../shared/components/Filters";
import DropdownField from "../../../../shared/components/DropdownField";


import { deserialize } from "serializr";
import { Formik, Form } from "formik";
import { INSTITUTE_STUDENT_VIEW } from "../../../../routes/routeConstants/appRoutes";
import { convertJsonToXslx } from "../../../../shared/utils/xlsxConverter";
import { StudentXslxHeaders } from "../../../../enums/studentXslxHeaders";
import {
  BASE_URL,
  EXISITING_STUDENT_DATA,
} from "../../../../routes/routeConstants/apiRoutes";


//services
import StudentService from "../../../../services/InstituteService/student.service";
import BranchService from "../../../../services/InstituteService/branch.service";
import SectionService from "../../../../services/InstituteService/section.service";

// models
import { Students } from "../../../../models/V2/InstituteModel/students.model";
import { FilterStudent } from "../../../../models/InstituteModel/students.model";
import { Institutes } from "../../../../models/InstituteModel/institutes.model";
import { BranchMetaModel } from "../../../../models/InstituteModel/branches.model";
import { PaginationModel } from "../../../../models/PaginationModel/pagination.model";
import InstituteStudentForm from './InstituteStudentForm';
import DeleteAlert from '../../../../shared/components/DeleteAlert';
import Notification from '../../../../shared/components/Notification';
import { NotificationTypes } from '../../../../enums/notificationTypes';
import V2StudentService from "../../../../services/v2/InstituteService/student.service";



export const renderErrors = (errors: any) => {
  let parsedErrors: any[] = [];
  for (const key in errors) {
    if (Array.isArray(errors[key])) {
      errors[key]?.map((value: any, index: number) => {
        parsedErrors.push(`${key}: ${value}`);
      });
    } else {
      parsedErrors.push(`Error: ${errors[key]}`);
    }
  }
  return parsedErrors;
};
const InstituteStudents: FC = (props: any) => {
  const { user } = props;
  const [currentStudent, setCurrentStudent] = useState<any>(null);
  const [students, setStudents] = useState<Students[]>([]);
  const [showForm, setFormVisibility] = useState(false);

  const [branches, setBranches] = useState<any>();
  const [classRooms, setClassRooms] = useState<any>();
  const [sections, setSections] = useState<any>();

  const [paginationMeta, setPaginationMeta] = useState<PaginationModel>({});

  const [showFilter, setFilterVisibility] = useState(false);
  const [filterValues, setFilterValues] = useState<any>({});
  const [filters, setFilters] = useState<FilterStudent>({
    page: 1,
    perpage: 10,
    search: "",
    is_active: true,
  });

  const { state }: { state: Institutes } = useLocation();
  const formRef = useRef<any>();
  const bulkUploadRef = useRef<HTMLInputElement>(null);

  const history = useHistory();
  const [showSpinModal, setSpinModalVisibility] = useState(false);
  const [uploadErrors, setUploadErrors] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false)
  const [showDeleteAlert, setShowDeleteAlert] = useState<boolean>(false);
  const [showBlacklistAlert, setShowBlacklistAlert] = useState<boolean>(false);
  const [blacklistReason, setBlacklistReason] = useState<string>('');
  const [showActive, setShowActive] = useState<boolean>(true);

  const getMenu =  () => {
    return (
      <Menu className="courses__card__menu">
        <Menu.Item
          key="edit"
          onClick={() => {
            setShowBlacklistAlert(true)
          }}
        >
          {currentStudent?.isBlocked ? 'Remove from blacklist' : 'Add to blacklist' }
        </Menu.Item>
        <Menu.Divider/>
        <Menu.Item
          key="update"
          onClick={() => {
            setFormVisibility(true)
          }}
        >
          Edit Student
        </Menu.Item>
        <Menu.Divider/>
        <Menu.Item
          key="delete"
          onClick={() => {
            setShowDeleteAlert(true);
          }}
        >
          Delete Student
        </Menu.Item>
      </Menu>
    );
  }

  const [menu, setMenu] = useState<any>(getMenu());

  useEffect(() => {
    setMenu(getMenu());
  }, [currentStudent])

  const fetchStudents = (params: FilterStudent) => {
    setLoading(true)

    V2StudentService.fetchStudents(
      { ...params, is_active: filters.is_active, institute_id: state?.id },
      (students: React.SetStateAction<Students[]>, meta: React.SetStateAction<PaginationModel>) => {
        setStudents(students);
        setPaginationMeta(meta);
      },
      () => { },
      () => { setLoading(false) }
    );
  };

  const deleteStudent = () => {
    StudentService.deleteStudent(
      currentStudent?.id,
      () => {
        setShowDeleteAlert(false);
        fetchStudents(filters);

        Notification({ message: "Student", description: "Student deleted successfully", type: NotificationTypes.SUCCESS });
      },
      () => {},
      () => {}
    );
  }

  const handleCreate = (file: any) => {
    setSpinModalVisibility(true);
    setUploadErrors(null);
    let jsonData = { attachment: file };
    let formData = convertJSONToFormData({ student_upload: jsonData });
    StudentService.createStudents(
      formData,
      () => {
        fetchStudents(filters);
        setSpinModalVisibility(false);
      },
      (errors: any) => {
        setUploadErrors(errors);
      },
      () => {
        if (bulkUploadRef?.current?.value) {
          bulkUploadRef.current.value = "";
        }
      }
    );
  };
  const handlePageChange = (page: number, pageSize: any) => {
    fetchStudents({ ...filters, page, perpage: pageSize });
  };

  const handleSearch = (() => {
    let debounceTimeout: ReturnType<typeof setTimeout>;

    return (value: string) => {
      if (debounceTimeout) {
        clearTimeout(debounceTimeout);
      }

      debounceTimeout = setTimeout(() => {
        setFilters({ ...filters, search: value });
      }, 1000);
    };
  })();

  const handleUpdate = () => {
    StudentService.updateStudent(
      currentStudent.id,
      {isBlocked: !currentStudent.isBlocked, blockedReason: blacklistReason},
      () => {
        setBlacklistReason('')
        fetchStudents(filters);
        setShowBlacklistAlert(false);
        Notification({ message: "Blacklist", description: `Student ${currentStudent?.isBlocked ? 'restored' : 'blacklisted'} successfully`, type: NotificationTypes.SUCCESS });
      },
      () => { },
      () => { }
    );
  };

  useEffect(() => {
    fetchStudents(filters);
  }, [filters]);

  useEffect(() => {
    fetchBranches({});
  }, [])

  const fetchBranches = (params: any) => {
    BranchService.fetchBranches(
      { ...params, institute_id: state?.id },
      (data: any) => {
        let meta = deserialize(BranchMetaModel, data);
        setBranches(meta);
      },
      () => { },
      () => { }
    );
  };
  const fetchClassRooms = (id: any) => {
    SectionService.fetchBranchClassRooms(
      { branch_id: id },
      (classrooms: any[]) => {
        let meta: any = [];
        classrooms?.map((value: { classRoom: { name: any; classRoomId: any; }; id: any; }, index: any) => {
          meta.push({
            label: value?.classRoom?.name,
            value: value?.id,
            id: value?.classRoom?.classRoomId,
          });
        });

        setClassRooms([...meta]);
      },
      () => { },
      () => { }
    );
  };
  const fetchSections = (id: any) => {
    SectionService.fetchSectionsMeta(
      { branch_class_room_id: id },
      (sections: any) => {
        setSections(sections);
      },
      () => { },
      () => { }
    );
  };
  const handleTemplateExcel = () => {
    convertJsonToXslx("students.xlsx", "Students", [
      StudentXslxHeaders.NAME,
      StudentXslxHeaders.ROLL_NUMBER,
      StudentXslxHeaders.SECTION_ID,
      StudentXslxHeaders.PHONE_NUMBER,
      StudentXslxHeaders.EMAIL,
      StudentXslxHeaders.DOB,
      StudentXslxHeaders.PASSWORD,
    ]);
  };

  const refreshHandler = () => {
    fetchStudents(filters);
  };

  const handleActiveChange = (checked: boolean) => {
    setFilters({...filters, is_active: checked})
    setShowActive(checked)
  }

  const updateCurrentStudent = (studentId: any) => {
    StudentService.getStudentsDetails(
      studentId,
      (details) => {
        setCurrentStudent(details);
      },
      () => {},
      () => {
        setLoading(false);
      }
    );
  };

  return (
    <div className="institute-students__container">
      <DeleteAlert
        visible={showDeleteAlert}
        setVisible={setShowDeleteAlert}
        deleteContent={"Are you sure to delete this student?"}
        deleteWarning={
          "On deleting, student will be permanently deleted from the system. All associated data will be deleted as well."
        }
        logo={ avatarPlaceholder }
        contentTitle={currentStudent?.name}
        contentSubject={currentStudent?.studentPhone}
        blacklist={undefined}
        setBlacklistReason={undefined}
        handleDelete={deleteStudent}
      />

      <DeleteAlert
        visible={showBlacklistAlert}
        setVisible={setShowBlacklistAlert}
        deleteContent={`Are you sure to ${currentStudent?.isBlocked ? 'remove' : 'add'} the student ${currentStudent?.isBlocked ? 'from' : 'to'} blacklist?`}
        deleteWarning={
          currentStudent?.isBlocked ? "Unblocking will allow the student to access all their associated information in their account" :
            "On blacklisting, Student loses access to the application"
        }
        logo={avatarPlaceholder}
        contentTitle={currentStudent?.fullName}
        contentSubject={currentStudent?.studentPhone}
        blacklist={currentStudent?.isBlocked ? "remove" : 'add'}
        setBlacklistReason={setBlacklistReason}
        handleDelete={handleUpdate}
        reason={blacklistReason}
      />
      <Modal
        visible={showSpinModal}
        title={null}
        footer={null}
        closable={uploadErrors ? true : false}
        centered
        onCancel={() => setSpinModalVisibility(false)}
        className="institute-students-spin__container"
      >
        <Spin
          className="institute-students__spin"
          tip="Creating students..."
          spinning={!uploadErrors}
        ></Spin>
        {uploadErrors &&
          renderErrors(uploadErrors)?.map((value, index) => {
            return <p className="error__text">{value}</p>;
          })}
      </Modal>
      <div className="header__wrapper">
        <div className="header__left">
          <SearchInput
            placeholder={"Search by any branch, class, section ..."}
            onChange={handleSearch}
          />
          <Button onClick={() => setFilterVisibility(true)}>
            <span>
              <FilterOutlined />
            </span>
            Apply Filter
          </Button>
          <div className="toggle__active">
            <Switch  checked={showActive} onChange={checked => handleActiveChange(checked)} /> Active
          </div>
        </div>
        <div className="header__right">
          {/* <ButtonComponent
            buttonContent="Assign Course"
            iconLeft={<PlusOutlined />}
            type="text"
            onClick={() => {}}
          /> */}
          <Dropdown
            overlayClassName="download__dropdown"
            trigger={["click"]}
            overlay={
              <Menu>
                <Menu.Item onClick={handleTemplateExcel}>
                  <p>Template Excel</p>
                </Menu.Item>
                <Menu.Item>
                  <p
                    onClick={() => {
                      var element = document.createElement("a");
                      element.href = BASE_URL + EXISITING_STUDENT_DATA;
                      element.click();
                    }}
                  >
                    Existing Data
                  </p>
                </Menu.Item>
              </Menu>
            }
            placement="bottomRight"
            arrow
          >
            <Button>
              <span>
                <DownloadOutlined />
              </span>
              Download
              <span>
                <CaretDownOutlined />
              </span>
            </Button>
          </Dropdown>

          {user?.roleName === 'admin' &&
            <ButtonComponent
              buttonContent="Bulk Upload"
              type="primary"
              onClick={() => {
                bulkUploadRef.current?.click();
              }}
            />}
          {(user?.roleName === 'admin' || user.email === "ssvmadmin@mail.com") &&
            <ButtonComponent
            className="header-add-btn"
            buttonContent={"Add"}
            type="primary"
            onClick={() => {
              setCurrentStudent(undefined);
              setFormVisibility(true)
            }}
          />}
        </div>
      </div>
      <input
        ref={bulkUploadRef}
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        type="file"
        style={{ display: "none" }}
        onChange={(e) => {
          let file = e.target.files?.length && e.target.files[0];
          handleCreate(file);
        }}
      />
      <InstituteStudentForm
        visible={showForm}
        closeHandler={() => {
          setFormVisibility(false);
          setCurrentStudent(undefined);
        }}
        data={currentStudent}
        refreshList={refreshHandler}
        apiMethod={() => fetchStudents(filters)}
      />
      <Table
        className="institute__table"
        // rowSelection={{
        //   type: "checkbox",
        //   ...rowSelection,
        // }}
        pagination={false}
        columns={[
          {
            title: "Name",
            dataIndex: "name",
            key: "name",
            render: (name, record) => (
              <p
                onClick={() =>
                  history.push(
                    generatePath(INSTITUTE_STUDENT_VIEW, {
                      instituteId: state?.id,
                      studentId: record?.id,
                    }),
                    record
                  )
                }
              >
                {name}
              </p>
            ),
          },
          {
            title: "Student ID",
            dataIndex: "id",
            key: "id",
          },
          {
            title: "Roll No.",
            dataIndex: "rollNumber",
            key: "rollNumber",
          },
          {
            title: "Branch",
            dataIndex: "branchName",
            key: "branchName"
          },
          {
            title: "Board",
            dataIndex: "boardName",
            key: "boardName"
          },
          {
            title: "Class",
            dataIndex: "className",
            key: "className"
          },
          {
            title: "Section",
            dataIndex: "sectionName",
            key: "sectionName"
          },
          {
            title: "Phone Number",
            dataIndex: "phoneNumber",
            key: "phoneNumber",
            render: (text) => <p>{text}</p>,
          },
          {
            title: "Email ID",
            dataIndex: "email",
            key: "email",
            render: (text) => <p>{text}</p>,
          },
          {
            dataIndex: "blacklist",
            render: (_, record) => (
              user?.roleName === 'admin' || user.email === "ssvmadmin@mail.com"
                ? <Dropdown
                  trigger={["click"]}
                  className="institute-student__menu"
                  overlayClassName="institute-student__menu-overlay"
                  overlay={
                    menu
                  }
                >
                  <div onClick={() => {
                    updateCurrentStudent(record.id)
                  }} >
                    <EllipsisOutlined rotate={90} />
                  </div>
                </Dropdown>
                : record?.isBlocked ? "Y" : "N"
            ),
          },
        ]}
        dataSource={students}
        loading={loading}
      />
      <PaginationComponent
        handlePageChange={handlePageChange}
        paginationMeta={paginationMeta}
      />
      <Formik
        initialValues={filterValues}
        onSubmit={() => { }}
        enableReinitialize
        innerRef={formRef}
      >
        {({ values, setFieldValue, resetForm }) => (
          <Filters
            expand={showFilter}
            handleApply={() => {
              setFilters({...filters, ...values})
              setFilterVisibility(false);
            }}
            handleReset={() => {
              resetForm(filterValues);
              setFilterVisibility(false);
              setFilters({is_active: showActive})
            }}
            closeHandler={() => setFilterVisibility(false)}
          >
            <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <div className="filter-form__input">
                <div className="filter-form__label">Branch</div>
                <DropdownField
                  name="branchId"
                  placeholder="Select branch"
                  options={branches}
                  value={values?.branchId}
                  onChange={(value: any) => {
                    setFieldValue("branchId", value);
                    fetchClassRooms(value);
                  }}
                  showSearch={false}
                  optionFilterProp="label"
                />
              </div>
              <div className="filter-form__input">
                <div className="filter-form__label">Class</div>
                <DropdownField
                  name="classRoomId"
                  placeholder="Select class"
                  options={classRooms}
                  value={values?.classRoomId}
                  onChange={(value: any) => {
                    setFieldValue("classRoomId", value);
                    fetchSections(value);
                  }}
                  showSearch={false}
                  optionFilterProp="label"
                />
              </div>
              <div className="filter-form__input">
                <div className="filter-form__label">Section</div>
                <DropdownField
                  name="sectionId"
                  placeholder="Select section"
                  options={sections}
                  value={values?.sectionId}
                  onChange={(value: any) => {
                    setFieldValue("sectionId", value);
                  }}
                  showSearch={false}
                  optionFilterProp="label"
                />
              </div>
            </Form>
          </Filters>
        )}
      </Formik>
    </div>
  );
};
export default InstituteStudents;
